import { useQuery } from 'react-query';
import { getCollegeName } from 'src/apis/collegeName';
import { GetCollegeNameAPIResponse } from 'types';

export const useGetCollegeName = ({
	page,
	limit,
	search,
	onComplete,
	handleError,
	allowedColleges,
}: {
	page?: number;
	limit?: number;
	search?: string;
	allowedColleges?: string;
	onComplete?: (data: GetCollegeNameAPIResponse) => void;
	handleError?: () => void;
}) => {
	return useQuery({
		queryKey: ['getCollegeName', page, limit, search],
		queryFn: async () => (await getCollegeName({ page, limit, search, allowedColleges })) as GetCollegeNameAPIResponse,
		staleTime: 0,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};
